import http from 'axios';
import { getCurrentSession } from '../helpers/auth';

const DEMAND_CLIENT_ID = process.env.REACT_APP_DEMAND_APP_CLIENT_ID;
const API_URL = process.env.REACT_APP_ORCHESTRATE_AUTH_API_URL;

const client = http.create({
  baseURL: `${API_URL}/auth`,
  timeout: 20000,
  headers: { 'Content-Type': 'application/json' },
});

client.interceptors.request.use(async (config) => {
  const { accessToken } = await getCurrentSession(DEMAND_CLIENT_ID, 'demand');
  if (accessToken) config.headers.Authorization = accessToken;
  return config;
});

const orchestrateAuthApi = {
  orgs: {
    list: () => client.get('/admin/orgs'),
    get: (orgId) => client.get(`/org/${orgId}`),
    create: (name) => client.post('/org', { name }),
    addMapping: (orgId, appName, appOrgId) =>
      client.post(`/org/${orgId}/app`, {
        app_name: appName,
        app_org_id: appOrgId,
      }),
    getByApp: (appName, appOrgId) =>
      client.get(`/org/by-app/${appName}/${appOrgId}`),
    addMember: (orgId, userSub, role = 'member') =>
      client.post(`/org/${orgId}/member`, { user_sub: userSub, role }),
    removeMember: (orgId, userSub) =>
      client.delete(`/org/${orgId}/member/${userSub}`),
  },
};

export default orchestrateAuthApi;
